import React, { ForwardedRef, forwardRef, InputHTMLAttributes, useCallback } from "react";

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "autoComplete"> & {
  autoComplete?: boolean;
  onChange?: (value: string, event: Event) => void;
};

export const Input = forwardRef(
  (
    { autoComplete, type = "text", name, onChange, value, ...props }: InputProps,
    ref: ForwardedRef<HTMLInputElement | null>
  ) => {
    const handleChange = useCallback(
      (event) => {
        const { value } = event.target;

        onChange?.(value, event);
      },
      [onChange]
    );

    const autoCompleteState = autoComplete ? "on" : "off";

    return (
      <input
        ref={ref}
        type={type}
        name={name}
        autoComplete={autoCompleteState}
        value={type !== "password" ? value : undefined}
        onChange={handleChange}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";
